// 获取供需信息
import request from '@/API/request';

export function createTransactionUser(data) {
  return request({
    url: 'auth/api/transaction-user',
    method: 'post',
    data,
  });
}
